<script setup lang="ts">
const contactLink = {
  label: 'お問い合わせ',
  path: 'mailto:contact@daikukaku.jp',
}

const navItems = [
  {
    label: '©国立研究開発法人農業・食品産業技術総合研究機構',
    path: 'https://www.naro.go.jp',
  },
  {
    label: '農村工学研究部門',
    path: 'https://www.naro.go.jp/laboratory/nire/',
  },
]
</script>

<template lang="pug">
footer.l-footer.js-footer
  .l-footer__links
    a.l-footer__link.l-footer__link--contact(:href="contactLink.path") {{ contactLink.label }}

    .l-footer__links-right
      a.l-footer__link(v-for="item in navItems" :key="item.path" :href="item.path" target="_blank") {{ item.label }}
</template>
